module.exports = __webpack_public_path__ + "static/media/plan-waves.1925ee92.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/NewPlanDetails/plan-waves.svg
 ** module id = 1317
 ** module chunks = 0
 **/